/**
 * Cache Constants
 * this file contains constants of cache keys
 * types: local storage, session storage, indexedDB, cookies
 * Naming Convention: SCREAMING_SNAKE_CASE
 * i.e. SEARCH_QUERY
 */

export const COOKIE_KEYS = {
  AUTH_TOKEN: "token",
  CURRENCY: "currency",
};

export const INDEXED_DB_STORAGE_KEYS = {};

export const LOCAL_STORAGE_KEYS = {
  CACHED_TRAVELLERS_MAP: "CACHED_TRAVELLERS_MAP",
  CACHED_CONTACT: "CACHED_CONTACT",
  FLIGHTS_SEARCH_BOX_STATE: "FLIGHTS_SEARCH_BOX_STATE",
  SAVE_COMPARE: "SAVE_COMPARE",
  ORIGIN_RECENT_SEARCH: "ORIGIN_RECENT_SEARCH",
  DESTINATION_RECENT_SEARCH: "DESTINATION_RECENT_SEARCH",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  BROWSER_SESSION_ID: "BROWSER_SESSION_ID",
  DIALCODE_RECENT_SELECTED: "DIALCODE_RECENT_SELECTED",
  COUNTRY_RECENT_SELECTED: "COUNTRY_RECENT_SELECTED",
  IS_INSURANCE_DIALOG_SHOWN: "isInsuranceDialogShown",
  FARE_CALENDAR_SELECTION: "fareCalendarSelection",
  FLIGHT_SEARCH_BOX_STATE: "FLIGHT_SEARCH_BOX_STATE",
  IS_FARE_CALENDAR_LAYOUT: "IS_FARE_CALENDAR_LAYOUT",
  FARE_CALENDAR: "fareCalendar",
};

export const SESSION_STORAGE_KEYS = {
  SELECTED_BAGGAGE_OPTIONS: "SELECTED_BAGGAGE_OPTIONS",
  FARE_FAMILES_META_CART: "FARE_FAMILES_META_CART",
  IS_12_HOURS_TIME_FORMAT: "is12HoursTimeFormat",
  EXTRA_BAGGAGE_OUTBOUND: "EXTRA_BAGGAGE_OUTBOUND",
  EXTRA_BAGGAGE_INBOUND: "EXTRA_BAGGAGE_INBOUND",
  PARTNER_REFERER: "partner_referer",
  META_FARE_FAMILIES_SHOWN: "META_FARE_FAMILIES_SHOWN",
  URGENCY_DISCLAIMER_SHOWN: "URGENCY_DISCLAIMER_SHOWN",
  CACHED_CONTACT_MEDIUM: "CACHED_CONTACT_MEDIUM",
  BOOOK_FOR_OTHERS_TOGGLE_STATE_KEY: "BOOOK_FOR_OTHERS_TOGGLE_STATE_KEY",
  FARE_CALENDAR_STATE_CHANGED: "FARE_CALENDAR_STATE_CHANGED",
};

export const COOKIES = {
  DRAWER_OPEN_TIME: "drawerOpenTime",
  USER_SELECTED_POS: "userSelectedPos",
};
